module.exports = __webpack_public_path__ + "img/violet_105.7dc573e5.png";